import {Modal, Row} from "react-bootstrap";
import React, {useContext, useEffect, useState} from "react";
import {Box, Divider, IconButton} from "@mui/material";
import {
  adminGetCompanyMemberships,
  adminSaveCompanyMemberships, adminSearchCompanyContext
} from "../common/api/WebApi";
import MDBox from "../../components/MDBox";
import MDInput from "../../components/MDInput";
import Icon from "@mui/material/Icon";
import {AppContext} from "../../lib/AppContext";
import useDebounce from "../common/useDebounce";
import MDButton from "../../components/MDButton";
import {useFieldArray, useForm} from "react-hook-form";

export default function AdminAssignMembershipModal({company, handleClose, handleSave, show}) {

  const [context, setContext] = useContext(AppContext);
  const [formInvalid, setFormInvalid] = useState(false);

  const [saving, setSaving] = useState(false);
  const [companyGuid, setCompanyGuid] = useState(null);
  const [companyId, setCompanyId] = useState(null);
  const [quickSearch, setQuickSearch] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [searchIndex, setSearchIndex] = useState(1);
  const [tmpResults, setTmpResults] = useState({});
  const [firstLoad, setFirstLoad] = useState(true);

  const [members, setMembers] = useState([]);

  const [memberships, setMemberships] = useState();

  useEffect(() => {
    console.dir(memberships);
  }, [memberships]);

  const lookupMemberships = async () => {
    adminGetCompanyMemberships(company).then((result) => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setMemberships(result);
      }
    })
  }
  useEffect(() => {
    lookupMemberships();
  }, [company]);

  const assignMemberships = (formData) => {
    console.dir(formData);
    let _members = [];
    for (let j in formData?.members) {
      let m = formData?.members[j];
      if (formData?.members[j].expirationDate) {
        m.expirationDate = new Date(formData?.members[j].expirationDate);
      } else {
        m.expirationDate = null;
      }
      _members.push(m);
    }
    let _req = {
      companyId: company.companyId,
      companyGuid: company.guid,
      members: _members
    }

    adminSaveCompanyMemberships(_req).then((resp) => {
      alert('Done!');
    });
  }

  const getSearchIndex = () => {
    return searchIndex;
  }

  useEffect(() => {
    let result = tmpResults;

    console.dir(result);

    if ((result?.searchIndex + 1) === (getSearchIndex() + 1)) {

      if (result.error) {
        // todo: handle error
      } else {
        setSearchResults(result?.resp);
        setFirstLoad(false);
      }
    }
  }, [tmpResults]);

  const searchContextFn = async (searchCriteria) => {

    let idx = searchIndex + 1;
    setSearchIndex(idx);

    let _search = {
      searchCriteria: searchCriteria,
      companyGuid: company?.guid,
      companyId: company?.companyId
    }

    console.dir(company);
    console.dir(_search);

    let result = await adminSearchCompanyContext(_search, idx);

    setTmpResults(result);

  };

  const debounceChanges = useDebounce(function (newChanges) {
    let result = searchContextFn(newChanges);
  }, 500, []); // every .5 seconds max

  useEffect(() => {
    debounceChanges(quickSearch);
  }, [quickSearch]);

  useEffect(() => {
    if (!quickSearch) {
      let _c = {...context};
      _c.contextSearchActive = false;
      setContext(_c);
      return;
    }
    debounceChanges(quickSearch);
  }, [quickSearch]);

  const handleModalClose = () => {
    handleClose();
  };

  useEffect(() => {
    setSaving(false);
  }, [show]);

  const toMemberItem = (member) => {
    return {
      memberGuid: member.guid,
      memberId: member.id,
      firstName: member.firstName,
      lastName: member.lastName,
      email: member.email
    }
  }

  const addMember = (newMember) => {
    let mm = toMemberItem(newMember);
    setMembers(prev =>
      prev.some(member => member.memberId === mm.memberId)
        ? prev
        : [...prev, mm]
    );
  }

  const {
    register, handleSubmit,
    setValue,
    control,
    reset,
    formState: {errors}
  } = useForm({
    defaultValues: {
      members: []
    }
  });

  const {fields} = useFieldArray({
    control,
    name: "members"
  });

  useEffect(() => {
    reset({members});
  }, [members, reset]);

  return (
    <>
      <Modal onHide={handleClose} size={'xl'} show={show && company}>
        <form
          onSubmit={handleSubmit(assignMemberships)} id={'assignMembershipsForm'}>
          <Modal.Header closeButton>
            <Modal.Title>Assign Membership</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Box>
                <div style={{
                  position: 'sticky',
                  top: '-20px',
                  zIndex: 19,
                  background: '#fff',
                  paddingTop: '20px',
                  marginTop: '-20px'
                }}>
                  <IconButton
                    size="small"
                    className={'pull-right'}
                    disableRipple
                    color="inherit"
                    onClick={(e) => {
                      handleClose();
                    }}
                  >
                    <Icon>close</Icon>
                  </IconButton>
                  <MDBox>
                    <MDInput
                      label="Search here"
                      value={quickSearch || ''}
                      onFocus={(e) => {

                      }}
                      onChange={(e) => {
                        setQuickSearch(e.target.value);
                      }}/>
                  </MDBox>

                  <Divider/>
                </div>
                <MDBox>
                  <h5>
                    Assigned Members
                  </h5>

                  <table className={'table table-striped'}>
                    <thead>
                    <tr>
                      <th>Member</th>
                      <th>Email</th>
                      <th>Option</th>
                      <th>Visits</th>
                      <th>Expiration Date</th>
                    </tr>
                    </thead>
                    <tbody>
                    {members?.map((member, idx) => {
                      return (<tr key={idx}>
                        <td>
                          {member.firstName} {member.lastName}
                        </td>
                        <td>
                          {member.email}
                        </td>
                        <td>
                          {memberships?.length > 0 && <>
                            <select
                              {...register(`members.${idx}.accountId`, {
                                valueAsNumber: true
                              })}
                              className="form-select"
                            >
                              {memberships?.map((m, idx) => {
                                return (<option key={idx} value={m.id}>
                                  {m.name}
                                </option>)
                              })}
                            </select>
                          </>}
                        </td>
                        <td>
                          <input
                            type="number"
                            min="0"
                            defaultValue={0}
                            {...register(`members.${idx}.numVisits`, {
                              valueAsNumber: true,
                            })}
                            className="form-control"
                          />
                        </td>
                        <td>
                          <input
                            type="date"
                            {...register(`members.${idx}.expirationDate`)}
                            className="form-control"
                          />
                        </td>
                      </tr>)
                    })}
                    </tbody>
                  </table>
                </MDBox>

                <MDBox>
                  <h5>
                    Customers
                  </h5>
                  <ul className={'list-group'}>

                    {searchResults?.members?.map((member, index) => {
                      return (
                        <li
                          className={'list-group-item'}
                          key={index}>
                          {member.firstName} {member.lastName}
                          <MDButton size={'small'} className={'pull-right'}
                                    color={'primary'} onClick={() => {
                            addMember(member);
                          }}>Add</MDButton>
                        </li>
                      );
                    })}

                  </ul>
                </MDBox>

              </Box>
            </Row>

          </Modal.Body>
          <Modal.Footer>
            <MDButton type="submit" color="info" disabled={formInvalid || saving}>
              {saving ? 'Saving...' : 'Save'}
            </MDButton>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
}